<template>
  <halo-dialog direction="bottom" :visible="visible" @cancel="cancel">
    <div class="hotel-dialog" @click="cancel">
      <div class="header-wrap">
        <img src="../images/close_icon.png" class="close-icon" />
      </div>
      <div class="hotel-list" v-if="list.length">
        <div
          class="hotel-item"
          v-for="item in list"
          :key="item.id"
          @click="select(item)"
        >
          <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }">
            <!-- <img src="../images/icon_360.png" class="icon" /> -->
            <!-- <div class="tags" v-if="item.tag">
              <div class="tag">#{{ item.tag }}</div>
            </div> -->
          </div>
          <div class="title-wrap">
            <div class="title ellipsis">{{ item.name }}</div>
            <div v-if="!$route.query.phone && item.min_price > 1" class="price">
              ¥{{ item.min_price }}起
            </div>
          </div>
          <div class="flex ellipsis" v-if="item.profile">
            <div class="desc">“{{ item.profile }}”</div>
          </div>
        </div>
      </div>
      <div class="blank-wrap" v-else>
        <img src="../images/blank.png" class="blank-icon" />
        <span>该场地暂无套餐服务</span>
      </div>
    </div>
  </halo-dialog>
</template>

<script>
import du from "@/utils/statistics";
import { toAppService } from "@/api/app";
import HaloDialog from "@/components/halo-dialog";
import { isMyApp } from "@/utils/util";
import { navigateTo } from "@/utils/app-router";

export default {
  components: {
    HaloDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["cancel"],
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    select(item) {
      let { hotel_id, hall_id, hotel_name } = item;
      du.trackEvent(
        "halldetail_service_click",
        "场地详情-点击套餐服务",
        `${hotel_id}-${hall_id}-${hotel_name}`
      );
      if (isMyApp) {
        return toAppService(item.id);
      }
      return navigateTo(`/pages/service-detail/index?id=${item.id}`);
    },
  },
};
</script>

<style lang="less" scoped>
.hotel-dialog {
  width: 100vw;
  max-height: 92vh;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  flex-direction: column;
}
.header-wrap {
  flex-shrink: 0;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  .close-icon {
    width: 54px;
    height: 24px;
  }
}

.hotel-list {
  display: flex;
  flex: 1;
  justify-content: center;
  flex-wrap: wrap;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  .hotel-item {
    width: 670px;
    padding-bottom: 40px;
  }
  .cover {
    height: 446px;
    background-color: #eee;
    position: relative;
    display: block;
  }
  .tags {
    position: absolute;
    top: 0;
    left: 0;
    .tag {
      height: 40px;
      background-color: black;
      display: flex;
      align-items: center;
      padding: 0 0.3em;
      color: white;
      font-size: 24px;
      margin-top: 12px;
      margin-left: 12px;
    }
  }
  .icon {
    width: 64px;
    height: 64px;
    position: absolute;
    left: 12px;
    bottom: 12px;
  }
  .title-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 0 16px;
  }
  .title {
    font-weight: bold;
    color: #333;
    font-size: 32px;
    font-weight: bold;
    width: 520px;
  }
  .desc {
    color: #666;
    font-weight: 400;
    font-size: 24px;
    height: 42px;
    line-height: 42px;
    padding: 0 12px;
    background: #f3f3f3;
    border-radius: 4px;
  }
  .price {
    font-weight: 600;
    font-size: 26px;
    text-align: right;
    padding-right: 0.6em;
    white-space: nowrap;
  }
}
.blank-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #999;
  font-size: 30px;
  padding: 80px 0;
  .blank-icon {
    width: 330px;
    height: 330px;
    object-fit: contain;
    object-position: center center;
    margin-bottom: 60px;
  }
}
</style>
